import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { useSelector } from "react-redux";
const InputValueDropDown = ({
  name,
  value,
  onChange,
  type,
  label,
  onBlur,
  required,
  options,
  disabled,
  error,
}) => {

  const {t} = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const isFees = label == "Fees";

  const currency = useSelector((state) => state.currency);
  useEffect(() => {
    console.log({ currency });
  }, [currency]);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen]);

  const commitUnit = (nextValue) => {
    const event = {
      target: {
        id: name[1],
        name: name[1],
        type: "select-one",
        value: nextValue,
        required: false,
        validity: {
          valueMissing: false,
          typeMismatch: false,
        },
      },
    };

    onChange(event);
    if (onBlur) {
      setTimeout(() => onBlur(event), 0);
    }
    setIsOpen(false);
  };

  return (
    <div className="child-register-combo-field">
      <label htmlFor={name[0]}>
        {t(label)} {required ? <span style={{ color: "red" }}>*</span> : null}
      </label>
      <div className={`child-register-combo-control${isFees ? " has-currency" : ""}`}>
      {isFees ? (
        <div className="child-register-combo-prefix">
          {currency[0]}
        </div>
      ) : null}
      <div className="form-group child-register-combo-input">
        <input
          min="1"
          type={type || "text"}
          className="form-control"
          id={name[0]}
          value={value[0]}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          required={required ? true : null}
        />
      </div>
      <div
        className="child-register-unit-select-field"
        ref={dropdownRef}
      >
        <button
          type="button"
          className="child-register-unit-select-trigger"
          disabled={disabled}
          id={name[1]}
          onClick={() => setIsOpen((current) => !current)}
          aria-haspopup="listbox"
          aria-expanded={isOpen}
        >
          <span>{t(value[1] || options?.[0] || "")}</span>
          <span className="material-icons">expand_more</span>
        </button>
        {isOpen ? (
          <div className="child-register-unit-select-menu" role="listbox">
            {options.map((option) => {
              const isSelected = option === value[1];
              return (
                <button
                  type="button"
                  key={option}
                  className={`child-register-unit-select-option${
                    isSelected ? " is-selected" : ""
                  }`}
                  onClick={() => commitUnit(option)}
                  role="option"
                  aria-selected={isSelected}
                >
                  <span>{t(option)}</span>
                  {isSelected ? <span className="material-icons">check</span> : null}
                </button>
              );
            })}
          </div>
        ) : null}
      </div>
      </div>
      {error ? <p className="red-text m-0">{t("Required field.")}</p> : null}
    </div>
  );
};
export default InputValueDropDown;
